import React from 'react';
import { Stack, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';

export interface SettingsToggleOption {
  value: string;
  label: string;
  icon?: React.ReactNode;
}

export interface SettingsToggleGroupProps {
  label: string;
  value: string;
  onChange: (v: string) => void;
  options: SettingsToggleOption[];
  exclusive?: boolean;
  disabled?: boolean;
  fullWidth?: boolean;
}

const SettingsToggleGroup: React.FC<SettingsToggleGroupProps> = ({
  label,
  value,
  onChange,
  options,
  exclusive = true,
  disabled,
  fullWidth = true,
}) => (
  <Stack spacing={0.5}>
    <Typography variant="caption" color="text.secondary">{label}</Typography>
    <ToggleButtonGroup
      exclusive={exclusive}
      value={value}
      onChange={(_, v) => { if (v != null) onChange(v); }}
      size="small"
      fullWidth={fullWidth}
      disabled={disabled}
    >
      {options.map((opt) => (
        <ToggleButton key={opt.value} value={opt.value}>
          {opt.icon ? (
            <Stack direction="row" spacing={0.5} alignItems="center">
              {opt.icon}
              <span>{opt.label}</span>
            </Stack>
          ) : (
            opt.label
          )}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  </Stack>
);

export default SettingsToggleGroup;
